import { Modal, notification } from "antd";
import { GraphQLClient } from "graphql-request";
import React, { useState } from "react";

import UserPicker from "@components/picker/UserPicker";

import { useService } from "@libs/hooks/useService";
import { GroupChallengeGroupEvaluation } from "@libs/service/graphql/generated/types";
import { addMentorIntoGroup } from "@libs/service/groupChallenge";

interface AssignReviewerModalProps {
  show: boolean;
  groupChallengeID: string;
  target?: GroupChallengeGroupEvaluation;
  groupName: string;
  onFinished(canceled?: boolean): void;
  onError(err: unknown): void;
}

type State = {
  sending: boolean;
  mentor: string;
};

const AssignReviewerModal: React.FC<AssignReviewerModalProps> = (props) => {
  const [state, setState] = useState<State>({
    sending: false,
    mentor: "",
  });
  const { apigatewayClient: client } = useService();

  function onUserSelected(id: string) {
    setState({ ...state, mentor: id });
  }

  async function handleAsignMentor(
    mentor: string,
    groupId: string,
    groupOfGroupChallengeId: string
  ) {
    setState({ ...state, sending: true });
    addMentorIntoGroup(
      client as GraphQLClient,
      mentor,
      groupId,
      groupOfGroupChallengeId
    )
      .then(() => {
        notification.success({
          message: "Success",
          description: "The mentor has been successfully assigned",
        });
      })
      .catch((err) => {
        console.error(err);
        notification.error({
          message: "Oops!",
          description: "Unable to add mentor, please try again later",
        });
      })
      .finally(() => {
        setState({ ...state, sending: false });
        props.onFinished();
      });
  }

  return (
    <>
      <Modal
        title="Assign Mentors to The Group"
        visible={props.show}
        onOk={() =>
          handleAsignMentor(
            state.mentor,
            props.groupChallengeID ?? "",
            props.target?.id ?? ""
          )
        }
        onCancel={() => {
          if (!state.sending) {
            props.onFinished(true);
          }
        }}
        okButtonProps={{ loading: state.sending }}
        cancelButtonProps={{ disabled: state.sending }}
      >
        {props.target && (
          <>
            <p>
              Select Mentors to assign Group Challenge <b>{props.groupName}</b>
            </p>
            <UserPicker
              onChange={onUserSelected}
              selectedId={state.mentor}
              disabled={state.sending}
            />
          </>
        )}
      </Modal>
    </>
  );
};

export default AssignReviewerModal;
